@let vm =
    {
        isLodgingRequested: isLodgingRequested$ | async,
    };

<div id="lodgingTab" class="tab flex flex-col gap-medpace">
    @if (!isLodgingAvailable()) {
        <medpace-alert [appearance]="'highlight'" [content]="nonAvailableMessage" />
    }
    @if (isLodgingAvailable() || vm.isLodgingRequested) {
        <medpace-needs-travel-radio-group
            [label]="'Will the patient need lodging?'"
            [isDisabled]="false"
            [isUpdate]="isUpdate()"
            [formCtrl]="formGroup().controls.needsTravel"
        />
        @if (formGroup().controls.needsTravel.value) {
            <div>
                <mds-divider />
                <mds-expansion-panel
                    class="expansion-panel-request !border-y-0"
                    [panelTitle]="'Lodging Preferences'"
                    [description]="'(from Patient Profile)'"
                >
                    <medpace-lodging-preferences
                        [formGroup]="formGroup().controls.travel.controls.preferences"
                        [mode]="'view'"
                    />
                </mds-expansion-panel>
                <mds-divider />
            </div>
            <medpace-lodging-request-details
                [mode]="mode()"
                [formGroup]="formGroup().controls.travel.controls.requestDetails"
            />
        }
    }
</div>
